import { Button, Group, Stack, Text } from '@mantine/core';
import AddToFirmButton from './AddToFirmButton';
import LibraryRow from './LibraryRow';
import LibraryTabPanel from './LibraryTabPanel';
import type { SkillLibraryEntryPage } from './types';

type CuratedSkillsTabProps = {
  page: SkillLibraryEntryPage | undefined;
  isLoading: boolean;
  isError: boolean;
  onRetry: () => void;
  onOpen: (entryId: string) => void;
  firmName: string | null;
};

export default function CuratedSkillsTab({
  page,
  isLoading,
  isError,
  onRetry,
  onOpen,
  firmName,
}: CuratedSkillsTabProps) {
  const items = page?.items ?? [];

  return (
    <Stack gap="md">
      <Text size="sm" c="dimmed">
        Shared by the Afternoon team.
      </Text>
      <LibraryTabPanel
        tabLabel="curated skills"
        isLoading={isLoading}
        isError={isError}
        onRetry={onRetry}
        isEmpty={items.length === 0}
        emptyTitle="No curated skills yet"
        emptyBody="The Afternoon team has not shared anything yet. Check back soon."
      >
        {items.map(entry => (
          <LibraryRow
            key={entry.id}
            entry={entry}
            action={
              <Group gap="xs" wrap="nowrap">
                <Button variant="default" onClick={() => onOpen(entry.id)}>
                  Read skill
                </Button>
                <AddToFirmButton entry={entry} firmName={firmName} />
              </Group>
            }
          />
        ))}
      </LibraryTabPanel>
    </Stack>
  );
}
